export default function getLatestAttempt(attempts: Array<Record<string, any>>) {
  if (!Array.isArray(attempts) || attempts.length === 0) {
    return null;
  }

  return attempts.reduce((latestAttempt, currentAttempt) => (
    currentAttempt.timestamp > latestAttempt.timestamp ? currentAttempt : latestAttempt
  ));
}
